import { withStyles } from '@material-ui/core/styles';
import Progress from '@material-ui/core/LinearProgress';

const LProgress = withStyles(() => ({
  root: {
    height: 4,
  },
  colorPrimary: {
    backgroundColor: 'var(--white-v2)',
  },
  bar: {
    backgroundColor: 'var(--primary-v2)',
  },
}))(Progress);

export const LinearProgress = ({
  loading = false,
  ...rest
}) => {
  const ProgressCollection = new Map([
    [true, (props = {}) => <LProgress {...props} />],
    [false, () => <></>],
  ]);

  const UI = ProgressCollection.get(loading);

  return (
    <UI {...rest} />
  )
};

export default LinearProgress;
